import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ActionSide } from '@beefco/types';
export function getDOMNodeRect(domNode) {
  var _domNode$getBoundingC = domNode.getBoundingClientRect(),
    top = _domNode$getBoundingC.top,
    left = _domNode$getBoundingC.left,
    width = _domNode$getBoundingC.width,
    height = _domNode$getBoundingC.height;
  return {
    top: top,
    left: left,
    width: width,
    height: height
  };
}
export function getDOMNodeWindowRect(domNode) {
  var rect = getDOMNodeRect(domNode);
  return _objectSpread(_objectSpread({}, rect), {}, {
    top: window.scrollY + rect.top,
    left: window.scrollX + rect.left
  });
}

/**
 * Calculate edge based on current cursorPosition and container position
 */
export var getCursorAxisEdge = function getCursorAxisEdge(current, start, size) {
  if (current < start + size * 0.25) return ActionSide.BEFORE;
  if (current > start + size * 0.75) return ActionSide.AFTER;
  return ActionSide.INSIDE;
};
export var getActionEdge = function getActionEdge(domNode, cursor) {
  if (!domNode || !cursor) return ActionSide.INSIDE;
  var nodeRect = getDOMNodeWindowRect(domNode);
  return getCursorAxisEdge(cursor.y, nodeRect.top, nodeRect.height);
};
export var extractCursorPoint = function extractCursorPoint(event) {
  return {
    x: event.pageX,
    y: event.pageY
  };
};
export function extractCursorRectPoint(event) {
  var nodeRect = getDOMNodeRect(event.target);
  return {
    x: event.pageX - nodeRect.left,
    y: event.pageY - nodeRect.top
  };
}
export function getRelationBySide(side) {
  switch (side) {
    case ActionSide.BEFORE:
      return 'beforeId';
    case ActionSide.AFTER:
      return 'afterId';
    case ActionSide.INSIDE:
    default:
      return 'parentId';
  }
}